<template>
    <el-drawer
        title="举报管理"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        :size="400"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="type" label="处理类型:">
                    <el-select v-model="formData.type" placeholder="请选择处理类型" size="medium">
                        <el-option :value="1" label="禁言"></el-option>
                        <el-option :value="2" label="仅标记已处理"></el-option>
                        <el-option :value="3" label="忽略"></el-option>
                    </el-select>
                </el-form-item>			
               <el-form-item prop="days" label="处罚力度:" v-if="formData.type == 1">
                   <el-select v-model="formData.days" placeholder="请选择处罚力度" size="medium">
                       <el-option :value="3" label="3天"></el-option>
                       <el-option :value="30" label="30天"></el-option>
                       <el-option :value="90" label="90天"></el-option>
                       <el-option :value="0" label="永久"></el-option>
                   </el-select>
               </el-form-item>
			   <el-form-item v-if="formData.type!=3 && type != 13 && type != 14 && type != 15" prop="isShieldAll" label="屏蔽处理:">
			       <el-select v-model="formData.isShieldAll" size="medium">
			           <el-option :value="2" label="用户自已可见"></el-option>
			           <el-option :value="-1" label="屏蔽当前动态"></el-option>
					   <el-option :value="1" label="屏蔽用户所有动态"></el-option>
					   <el-option :value="3" label="取消屏蔽（全部可见）"></el-option>
			       </el-select>
			   </el-form-item>
			   <el-form-item v-if="formData.type!=3 && type == 15" prop="isShieldAll" label="屏蔽处理:">
			       <el-select v-model="formData.isShieldAll" size="medium">			           
			           <el-option :value="-1" label="屏蔽当前卡片"></el-option>					   
					   <el-option :value="3" label="取消屏蔽（当前卡片全部可见）"></el-option>
			       </el-select>
			   </el-form-item>
			   <el-form-item  v-if="formData.type!=3" prop="remark" label="结果通知:">
			       <el-input placeholder="请输入结果通知" v-model="formData.remark" size="medium" type="textarea" :autosize="true" maxlength="100" show-word-limit></el-input>
			   </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close()">取消</el-button>
            <el-button                
                type="primary"
                @click="onSubmit"
                :loading="btnLoading"
                >确认处理</el-button
            >
        </div>
    </el-drawer>
</template>
<script>

export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                days: 3,
                id: '',
                isShieldAll: '',
                remark:'感谢您的反馈。经核实您提供的资料已采纳，被举报内容已处理，感谢您对秀动的支持！',
                type: 1,
                userId:''
            } ,
			type:''
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;           
        },
        show(id,mainId,type){
			
			this.type = type		
			
            if( id ){
                this.formData.id = id;
				this.formData.userId = mainId
				
            }
            this.drawerShow = true;
        },
       
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/report/content/handle',
                        method: "POST",
                        data: {
                            ...this.formData,
                            id: this.formData.id,
                            userId: this.formData.userId,
                            isShieldAll: this.formData.type == 3 ? 0 : this.formData.isShieldAll
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
       
    }
}
</script>

<style lang="scss" scoped>

</style>